import { ShipVisit } from '@/routes/(app)/(scenarios)/(create)/types';

/** Must stay aligned with `useShipmentTableColumns` accessor keys. */
const EDITABLE_SHIP_VISIT_COLUMN_IDS = [
  'id',
  'ship_id',
  'shipping_line_id',
  'arrival_time',
  'departure_time',
  'n_moves_discharge',
  'n_moves_load',
] as const satisfies ReadonlyArray<keyof ShipVisit>;

export function isEditableShipVisitColumnId(
  columnId: string
): columnId is (typeof EDITABLE_SHIP_VISIT_COLUMN_IDS)[number] {
  return EDITABLE_SHIP_VISIT_COLUMN_IDS.some((key) => key === columnId);
}
